module.exports = __webpack_public_path__ + "static/media/hero-vbn-mobile.715c5be0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-vbn-mobile.webp
// module id = 207
// module chunks = 51